module.exports = __webpack_public_path__ + "static/logo-development-becd20ebbf6d8eb954756dd1e62eff90.png";